import { Flex, Typography } from '@iheartjane/reefer';
import { Form } from '@iheartjane/reefer-hook-form';

import { useGlobalSpecialsModal } from '@jane/business-admin/providers/GlobalSpecialsModalProvider';
import type { SpecialTypeProps } from '@jane/business-admin/types';

export const CartTotal = ({ name }: SpecialTypeProps['cart_total']) => {
  const { isDisabled } = useGlobalSpecialsModal();

  return (
    <Flex mb={24} width={'100%'} flexDirection="column">
      <>
        <Form.NumberField
          width="50%"
          name={`${name}.threshold`}
          label="Cart total threshold"
          mb={4}
          disabled={isDisabled}
          disableOnWheel
        />
        <Typography color="grays-mid" variant="body" mt={16}>
          Enter the cart total the customer must reach to activate this special.
        </Typography>
      </>
    </Flex>
  );
};
